<template>
  <div class="mainContent">
    <h1 class="mainContent__title">Minha Agenda</h1>
    <div class="card">
      <div class="card__header">
        <div class="card__header--container">
          <Button
            class="calendar__today"
            v-bind="{ secondary: !selectedDayIsToday }"
            @click="handleSelectToday"
          >
            Hoje
          </Button>
          <div class="calendar__title textOverflow">
            {{ calendarTitle }}
          </div>
        </div>
      </div>
      <div class="card__body">
        <WeekCarousel ref="weekCarouselRef" />
        <div class="currContent">
          <div class="currContent__info">
            <div class="currContent__info--left">
              <span class="currContent__date">
                {{ selectedDay.format('DD/MM/YYYY') }}
              </span>
              <span class="currContent__meetCount">
                {{ meetCountLabel }}
              </span>
            </div>
            <div
              v-if="isProfessionalRedeConexa"
              class="currContent__info--right"
            >
              <span class="currContent__title">Plantão:</span>
              <SwitchBtn
                :value="isOnDuty"
                :loading="loadingDuty"
                @change="toggleDuty"
              />
            </div>
          </div>
          <div class="currContent__meetings">
            <div v-if="loadingMeetings" class="currContent__meetings--loading">
              <Spinner />
            </div>
            <div
              v-else-if="notCanceledMeetings.length"
              class="currContent__meetings--list"
            >
              <MeetingItem
                v-for="meeting in notCanceledMeetings"
                :key="meeting.id"
                :itemData="meeting"
                class="fadeIn"
              />
            </div>
            <div v-else class="currContent__meetings--empty fadeIn">
              <span>
                Nenhum atendimento marcado para
                <strong>
                  {{ selectedDay.calendar(null, calendarConfig) }}.
                </strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Queue v-if="availabilityFlagForQueue && isProfessionalRedeConexa" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import titleByWeek from '@/utils/titleByWeek';
import WeekCarousel from './WeekCarousel';
import MeetingItem from './MeetingItem';
import Queue from '@/components/Queue';
import { calendarConfig } from '@/utils/moment';
import Spinner from '@/components/Spinner';
import SwitchBtn from '@/components/SwitchBtn';
import Button from '@/components/Button';

export default {
  name: 'MainContent',
  components: { WeekCarousel, MeetingItem, Spinner, Queue, Button, SwitchBtn },

  data() {
    return {
      calendarConfig,
      switchValue: false,
      professionalDuty: false,
    };
  },

  computed: {
    ...mapGetters('dashboard/calendar', ['activedWeek', 'selectedDayIsToday']),
    ...mapGetters('dashboard', ['currWorkspace']),
    ...mapGetters('queue', ['availabilityFlagForQueue']),
    ...mapGetters('meeting', ['notCanceledMeetings']),
    ...mapGetters('auth', ['isProfessionalRedeConexa']),
    ...mapState('dashboard', ['loadingDuty', 'isOnDuty']),
    ...mapState('meeting', ['loadingMeetings']),
    ...mapState('dashboard/calendar', ['today', 'selectedDay']),

    calendarTitle() {
      return titleByWeek(this.activedWeek);
    },

    meetCountLabel() {
      const count = this.notCanceledMeetings.length;
      return `${count} compromisso${count !== 1 ? 's' : ''}`;
    },
  },

  watch: {
    selectedDay() {
      this.handleFetchMeetings();
    },
  },

  created() {
    this.handleFetchMeetings();

    if (this.isProfessionalRedeConexa) {
      this.fetchDuty();
    }
  },

  methods: {
    ...mapActions('dashboard/calendar', ['setSelectedDay']),
    ...mapActions('dashboard', ['handleFetchDuty', 'toggleDuty', 'fetchDuty']),
    ...mapActions('meeting', ['setMeetings', 'handleFetchMeetings']),
    handleSelectToday() {
      const { selectedDayIsToday, setSelectedDay, today, $refs: refs } = this;
      if (selectedDayIsToday) return;
      setSelectedDay(today);
      refs.weekCarouselRef.$refs.carousel.goTo(1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
